"viteでのbuild時にファイルの内容が書き込まれるので手で編集しない";
export const specificationJsons = {
  "aeonretail_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "pickingList": {},
          "paperPickingList": {
            "productCodePosition": "PRODUCT_CODE_POSITION_RECORD_LINE_BOTTOM"
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableProductOriginLabelPrinting": true,
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.1
          },
          "productCodeScanLogicType": "PRODUCT_CODE_SCAN_LOGIC_TYPE_B"
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://netsuperguide.aeon.com/kb/article/再配達について/"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "サービスカウンター"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_SECOND"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://netsuperguide.aeon.com/kb/contact/"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "生活応援",
          "imagePath": "/icons/sales_badges/aeonretail_life-support.png"
        },
        {
          "badgeId": 2,
          "label": "新商品",
          "imagePath": "/icons/sales_badges/aeonretail_new-product.png"
        },
        {
          "badgeId": 3,
          "label": "おすすめ品",
          "imagePath": "/icons/sales_badges/aeonretail_recommended-product.png"
        },
        {
          "badgeId": 4,
          "label": "お得値まつり",
          "imagePath": "/icons/sales_badges/aeonretail_otokune-festival.png"
        }
      ],
      "enablePointCampaign": true
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "paygent": {
              "development": {
                "merchantId": "55431",
                "tokenGenerateKey": "test_i3XnPhR2CjJkJvBoaJGYxvRF",
                "scriptUrl": "https://sandbox.paygent.co.jp/js/PaygentToken.js"
              },
              "production": {
                "merchantId": "65423",
                "tokenGenerateKey": "live_RYrwz80iNVeGWmuHu38cBSGg",
                "scriptUrl": "https://token.paygent.co.jp/js/PaygentToken.js"
              }
            }
          }
        },
        {
          "cashOnDelivery": {
            "withFee": {
              "amount": 300,
              "taxType": "TAX_TYPE_EXCLUDED"
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 16,
          "formLabel": "WAON POINT",
          "infoCaption": "iAEONで登録されたポイントカードと紐づいています。ポイントカード情報はiAEONアプリからご確認ください。"
        },
        "stailerEstimatesPoint": {
          "showEstimatedPoint": true,
          "estimationParameter": {
            "pointReturnRate": "0.005",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {},
            "pointCalculationBasis": "POINT_CALCULATION_BASIS_TAX_INCLUDED"
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        }
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "externalIdAuthentication": {
        "authenticationScreenTitle": "イオン従業員ID認証"
      }
    },
    "service": {
      "name": "おうちでイオン イオンネットスーパー",
      "shortName": "イオンリテール"
    }
  },
  "albis_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          }
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "specified": {
            "digit": 3
          },
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.25
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/f36e994db1124b85bbacb6f41a3abd50"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "サービスカウンター"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/609fa14cd8494e13a2e560e7fb543143"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      }
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "6678363e-933f-4291-869e-a59dbe4dc9b0"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 1
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 15,
          "formLabel": "Ponta会員ID",
          "registerCaption": "Pontaカードを連携してください",
          "infoCaption": "※ポイントの加算は、商品お届け日の1~2日後を予定しています。",
          "orderConfirmDescription": "Pontaカードをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/6f7cbd096baf479b884c2ab996ce7fdb"
        },
        "stailerEstimatesPoint": {
          "showEstimatedPoint": true,
          "estimationParameter": {
            "pointReturnRate": "0.005",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        },
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {},
      "orderConfirmation": {},
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "schedulerFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "アルビスネットスーパー",
      "shortName": "アルビス"
    }
  },
  "aruk_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {
            "defaultPaperPickingListSelecting": "PAPER_PICKING_LIST_SELECTING_NEXT_DAY"
          },
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.2
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "useExternalCarrier": {
                "availableCarriers": [
                  "EXTERNAL_CARRIER_TYPE_YAMATO"
                ]
              }
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/50fb8b24872f4541b75312c2d7198a51"
          }
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/_-acb8ecbe0ad54a28a2698d66b4ed4d17"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      }
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp",
                "shopId": "9200006383713",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5ly/ccS6T1enPW3eslOs/RylnAqzGVUDwFw5JFumQzZzhYTpyq7NE4qbaw4WdbopxKXgRm9r1PUMZwweICIUPk28JfIKreJ1z72bDUHbhESDvzni/OXNmD1vJpDtV33wMJZ//JHJIiqF8lod3Jx6pRKqNQswYyMbWI8ZP6ZOzQkbaM4xP/34yhKugUpoLs3bk2QiDcSbzFqlb/fBkcmIoNrXxb7d+AIYkJaiXCd48eqiy5WuSoLqBXUpCsUGokb9tzEL2WovNUyeJxbFDiSNq3Xt2llU2nEgV/e8R7b+ivs3XgAKlC9dNEFbAFOLv0VKFyfTWn/+e0WUDSuzJgDENQIDAQAB",
                "keyHash": "4bff71f5e3cd881aaca131a7906fb5b5e89b26fc88a3e7694fcd10b45c9e29b1"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "disablePointCard": {}
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {},
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED",
        "hasRedeliveryFee": true
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "アルクネットスーパー",
      "shortName": "アルク"
    }
  },
  "delicia_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {
            "defaultPaperPickingListSelecting": "PAPER_PICKING_LIST_SELECTING_NEXT_DAY"
          },
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableProductOriginLabelPrinting": true,
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "specified": {
            "digit": 4
          },
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.1
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "deliciaYamato": {
                "shopIds": [
                  "23",
                  "82",
                  "410",
                  "411"
                ]
              }
            },
            {
              "dss": {}
            }
          ],
          "disableRedelivery": {}
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/34f92df48217448bb90912d6c9371327"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/delicia_recommended-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200004827219",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAylmvOJKd6CUtlNBBnAje3RkjsDQ1ldyDCCRgp3xd3vrMT3MGWNvydj5RyIFqDShYUW+s9R9vfzdGWgG6lg8j+Ct0PgpX4Zq6KXsK0WfopKBssJpF1d8LAQ1jhhj2g9EiGOpDtclCOCEHXGHQ6FTkye6y/6tywlKgYB7hXukGdIR1GyxJBg56mYS87110zxPyvbHv+LPv673samVinTBEh+Ojw/M0HePe8ZzPL4MH6TZan8zGOGUVEqjQ4stSK7mDI26yiQSGAf8i6YFTggzCiAEw62v2AICFK1xt2IQI/4GdFmgxX3SNF41VFRhJFOcx/B2JinlNuosz1dYeMlDq/wIDAQAB",
                "keyHash": "c032b3a5840a3cf8db8847c773c2a32398783619b10cb681cad772be4fc55836"
              }
            }
          }
        },
        {
          "cashOnDelivery": {
            "withFee": {
              "amount": 200,
              "taxType": "TAX_TYPE_EXCLUDED"
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 13,
          "formLabel": "ピコカプラス",
          "registerCaption": "ポイントカードの「ピコカプラス」と連携してください。",
          "infoCaption": "ポイントは、商品のお届け日から1週間前後での加算を予定しています。",
          "orderConfirmDescription": "ピコカプラスをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/3a018d9b80fb45b78316ec398ea00800"
        },
        "stailerEstimatesPoint": {
          "estimationParameter": {
            "pointReturnRate": "0.005",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        },
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "デリシア ネットスーパー",
      "shortName": "デリシア"
    }
  },
  "demo_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {},
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableProductOriginLabelPrinting": true,
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {},
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.25
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/0566573c4d5c4ba59a4700ea9fac3fa7"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "サービスカウンター"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/39538ed07e4349ceb23225d3b21a296a"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "disableCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      }
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              }
            }
          }
        },
        {
          "cashOnDelivery": {
            "noFee": {}
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "disablePointCard": {}
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "Stailerネットスーパー",
      "shortName": "Stailer"
    }
  },
  "fresta_service_specification.json": {
    "fulfillment": {
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "frestaDelivery": {}
            }
          ],
          "disableRedelivery": {}
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "enableFrestaCatalog": {
        "catalogOrderNumberRule": {
          "reuseCatalogTypeOrderNumbers": [
            {
              "catalogType": "CATALOG_TYPE_NORMAL",
              "catalogTypeOrderNumber": "0"
            }
          ],
          "rotationCatalogTypeOrderNumbers": [
            {
              "catalogType": "CATALOG_TYPE_RESERVATION",
              "catalogTypeOrderNumbers": [
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9"
              ]
            }
          ]
        },
        "catalogUpdateDeadlineRule": {
          "updateCatalogDeadlineDays": 1
        }
      },
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "zendeskInquiry": {
        "inquiryUrl": "https://frestahelp.zendesk.com/hc/ja/articles/22442484101913"
      },
      "enableFrestaIvr": {
        "hasSameSiteUserIdAndIvrCustomerNumber": true
      }
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {},
      "salesBadges": [
        {
          "badgeId": 2,
          "label": "日替わり",
          "imagePath": "/icons/sales_badges/fresta_daily-sale-product.png"
        },
        {
          "badgeId": 3,
          "label": "月安",
          "imagePath": "/icons/sales_badges/fresta_montyly-sale-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "19be9fd3-8584-4bb1-a8d5-0dec7511385c"
              }
            }
          }
        },
        {
          "bankAccountTransfer": {}
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "frestaPoint": {},
        "storeCardNumber": {},
        "showPointBalance": true,
        "uiSetting": {
          "cardNumberMaxLength": 10,
          "formLabel": "フレスタスマイルカード",
          "infoCaption": "※ポイントの加算は、商品お届け日の1~2日後を予定しています。",
          "orderConfirmDescription": "フレスタスマイルカードをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://frestahelp.zendesk.com/hc/ja/articles/27393711828633"
        },
        "stailerEstimatesPoint": {
          "showEstimatedPoint": true,
          "estimationParameter": {
            "pointReturnRate": "0.005",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        },
        "enableUnlink": true
      }
    },
    "masterData": {
      "enableMultipleMasterDataUpload": true
    },
    "customerOrder": {
      "customerRequest": {},
      "orderConfirmation": {},
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "schedulerFinalization": {}
    },
    "account": {
      "disableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "エブリデイフレスタ",
      "shortName": "フレスタ"
    }
  },
  "fuji_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {},
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableProductOriginLabelPrinting": true,
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.3
          },
          "productCodeScanLogicType": "PRODUCT_CODE_SCAN_LOGIC_TYPE_B"
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableCashOnDeliverySettlement": {}
              }
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/a64941a69d62404c99bd5e9aa02ca402"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "サービスカウンター"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_SECOND"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/WIP-f78a5288b60047ab86c108935ab71733"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      }
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "99a89550-27fc-432a-bf6a-f58f4b20831c"
              }
            }
          }
        },
        {
          "cashOnDelivery": {
            "withFee": {
              "amount": 200,
              "taxType": "TAX_TYPE_EXCLUDED"
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 14,
          "formLabel": "エフカ",
          "registerCaption": "エフカポイントをためることができます",
          "orderConfirmDescription": "エフカをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/3506f3ea11874ccd8cd28ca9d7eadd64"
        },
        "stailerEstimatesPoint": {
          "showEstimatedPoint": true,
          "estimationParameter": {
            "pointReturnRate": "0.01",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        },
        "enableUnlink": true
      }
    },
    "masterData": {
      "enableMultipleMasterDataUpload": true
    },
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED",
        "hasRedeliveryFee": true
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "フジネットスーパーおまかせくん",
      "shortName": "フジ"
    }
  },
  "heiwado_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {},
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {},
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.25
          },
          "productCodeScanLogicType": "PRODUCT_CODE_SCAN_LOGIC_TYPE_B"
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/332c07211c4b4633b0dfa62e40e2b7b7"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "銘店"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/4cab0c408e1640d190b67be62e553884"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "おすすめ",
          "imagePath": "/icons/sales_badges/heiwado_recommended-product.png"
        },
        {
          "badgeId": 2,
          "label": "ハトオシ",
          "imagePath": "/icons/sales_badges/heiwado_hatooshi-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200005192866",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApC2zkB5eB11VhtGPB/YLNZ6+MJzmBj0k3lpovfRL+cFUg8l5OPas0av6rC8uaOHomrICWce8+ANca14MVB+JiQ2Px02hARNuvh5a8RWZ6ZGIvn2N+jpCNcKYJ4mBRYH16PqjVb5SKDEsnkCCYvY2hwxUdLvUMgmJnMDudZQfORwyeVTRCHQkVWFL0D4edFwJX4TAbT+7F89NBy9+W90W3osEvXHOpwvuyvzDYkeJ3iH8lutB3B/dnRe5lR2NBV5Zu+A0ALxnA/CeN/kTIpwuumKsYJ62pLGNCJIZYBLlM7OaZqcaa42S6OdnP/7toPs9ns7rNGvDmI7ZhfsYVh0LHwIDAQAB",
                "keyHash": "37754486e18ed07d3b43596ee544b4666da9e5b45d529761b838cd59794ce2a9"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "hopPoint": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 13,
          "formLabel": "HOPカード",
          "registerCaption": "本人確認がお済みのHOPカードを連携してください。",
          "infoCaption": "※磁気不良等でHOPカード番号が変更となった際、HOPウォレットを利用されているお客様はHOPウォレットのみHOPカード番号変更いただきますと、こちらでの変更手続きは不要となります。",
          "orderConfirmDescription": "HOPカード情報を登録し、HOPVISAカードで決済するとHOPポイントが貯まります！",
          "setupGuideUrl": "https://10xall.notion.site/3aea90c3d3f34b7c9fae3f83da60366f"
        },
        "stailerEstimatesPoint": {
          "estimationParameter": {
            "pointReturnRate": "0.01",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "disableEarnedPointInReceipt": {},
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "平和堂ネットスーパー",
      "shortName": "平和堂"
    }
  },
  "life_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "pickingList": {
            "itemAggregatingCategoryOrder": "PICKING_LIST_ITEM_AGGREGATING_CATEGORY_ORDER_CATEGORY_SPECIFIED_PICKING_ORDER"
          },
          "paperPickingList": {
            "productCodePosition": "PRODUCT_CODE_POSITION_UNDER_PRODUCT_NAME"
          },
          "staffAppPickingList": {
            "enableBreakdownOrdererOnTotalPickingList": true,
            "enableDisplayingProductCode": true
          },
          "enableProductOriginLabelPrinting": true,
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "specified": {
            "digit": 4
          },
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 2
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "enableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {}
        },
        "enableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "enableBundleMixmatch": true,
      "medicine": {},
      "alcohol": {
        "enableEditAlcoholSalesManagementInfo": true
      }
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/28d112547e24405dbb0b2e15a1dc6534"
      },
      "disableIvr": {},
      "contactManagementType": "CONTACT_MANAGEMENT_TYPE_STATUS_CONTROL"
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 3,
          "label": "定番",
          "imagePath": "/icons/sales_badges/life_standard-product.png"
        },
        {
          "badgeId": 4,
          "label": "日替わり",
          "imagePath": "/icons/sales_badges/life_daily-sale-product.png"
        },
        {
          "badgeId": 5,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/life_advertised-product.png"
        },
        {
          "badgeId": 6,
          "label": "おすすめ",
          "imagePath": "/icons/sales_badges/life_recommended-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "3a9452bc-9031-418b-afe7-4abdc3b2b928"
              }
            }
          }
        },
        {
          "cashOnDelivery": {
            "withFee": {
              "amount": 110,
              "taxType": "TAX_TYPE_INCLUDED"
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 1
      },
      "enablePointCard": {
        "lacuca": {},
        "storeCardNumber": {},
        "showPointBalance": true,
        "enableRedeem": true,
        "uiSetting": {
          "cardNumberMaxLength": 13,
          "formLabel": "カード番号",
          "registerCaption": "LaCuCaまたはLC JCBカードを連携してください",
          "infoCaption": "※ポイントの加算は、商品お届け日の1~2日後を予定しています。",
          "orderConfirmDescription": "LaCuCaまたはLC JCBカードをアプリに登録するとポイントを使用・貯めることができます。",
          "showSplitEarnedPoint": true
        },
        "stailerEstimatesPoint": {
          "showEstimatedPoint": true,
          "estimationParameter": {
            "pointReturnRate": "0.005",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        },
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "disableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "ライフネットスーパー",
      "shortName": "ライフ"
    }
  },
  "matsuya_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {},
          "pickingList": {},
          "paperPickingList": {
            "productCodePosition": "PRODUCT_CODE_POSITION_UNDER_PRODUCT_NAME"
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "specified": {
            "digit": 4
          },
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.1
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/21d3747cdaf180d9868ee835ff4e8a22"
          }
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/21e3747cdaf1802ab4aed3216787014a"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "おすすめ",
          "imagePath": "/icons/sales_badges/matsuya_recommended.png"
        },
        {
          "badgeId": 2,
          "label": "日替わり",
          "imagePath": "/icons/sales_badges/matsuya_daily-sale.png"
        },
        {
          "badgeId": 3,
          "label": "お買い得商品",
          "imagePath": "/icons/sales_badges/matsuya_good-deal.png"
        },
        {
          "badgeId": 4,
          "label": "ネット限定",
          "imagePath": "/icons/sales_badges/matsuya_net-super-only-product.png"
        },
        {
          "badgeId": 5,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/matsuya_advertised-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200008561263",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvqCyqmsFK9UDtI4eeLvYDeC/e+vvmm08uqfBFerYtAUtA2gVvmd+mPxzeYJLsRU2rRRJ4lLNXuPdiJo/Ka2q9VsfR0PU7aN/k1zJbtY9U68vJq+FX+hurSNtlhPoS8/3Sem7AyXlbPXu7ZT/mNNQXk6ImGXE4/xAbwWCC+ZKHp4MlU6IOWQCL1UCyJVE9iyVCkFKYHuamE89LhMmH/VAeAH5DjOFPd32zYpSyvvATajzMyqoNxICDKYa4WZizDaWLhfd06JMD+ZiT/mfKAductzsljyK2wXwwvQlXKpFwmLB+y1lT+4cn/K/+uDgq9p+HgygvAIq8hkvb4H3u5797wIDAQAB",
                "keyHash": "bd0c9131d4cc426a27f6cc0b9b7cf3e9d43421a16f0596de11c1b9116fa10bbc"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "disablePointCard": {}
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "マツヤネットスーパー",
      "shortName": "マツヤ"
    }
  },
  "ogino_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {
            "defaultPaperPickingListSelecting": "PAPER_PICKING_LIST_SELECTING_NEXT_DAY"
          },
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1
          },
          "productCodeScanLogicType": "PRODUCT_CODE_SCAN_LOGIC_TYPE_B"
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "disableRedelivery": {}
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/5a1f345a212042ae8b29efbb96aca3fd"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "ネット限定",
          "imagePath": "/icons/sales_badges/ogino_netsuper-only.png"
        },
        {
          "badgeId": 2,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/ogino_advertised.png"
        },
        {
          "badgeId": 3,
          "label": "おすすめ",
          "imagePath": "/icons/sales_badges/ogino_recommended.png"
        },
        {
          "badgeId": 4,
          "label": "パワープライス",
          "imagePath": "/icons/sales_badges/ogino_power-price.png"
        },
        {
          "badgeId": 5,
          "label": "オギノセレクトプレミアム",
          "imagePath": "/icons/sales_badges/ogino_select-premium.png"
        },
        {
          "badgeId": 6,
          "label": "オギノセレクト",
          "imagePath": "/icons/sales_badges/ogino_select.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200006299953",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyWV7w4PXTgYP/qLjwhZ/QR1F6oDIqB0DbPbERujUAjwAaK5ttXAmwVo2HahZAFM/+61UP55GtGQiZvN3E79vK9WX+4IdEVpRrF4ARhFrR1k6s+H7rSw1QSPzmL2uxqWIuPEEc18+dpQipY+nvF9i+AxVZCoq8t46n9BLi4qv6IqiDSYRUDDeD+6cFwzmNFJo2Wh4lsTUP2+v/L6x54pvhgcdjZBPlPWhxu4G4pSv1WlT+K/USiiy1qa3OTWzz5v/RrkhAXryT7Aph5iKwhhuIa1iVDkhCcnKHCjzKI/mpWYqbFzmfIKfFUbHwiEW1PZyqwFXM5L1XF/XQzkyAm0LyQIDAQAB",
                "keyHash": "0144a6c7067744bbbefe028d54a16a69c2640233da8d021fc211884680b6296e"
              }
            }
          }
        },
        {
          "cashOnDelivery": {
            "noFee": {}
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 13,
          "formLabel": "オギノグリーンスタンプCoGCaカード",
          "registerCaption": "オギノグリーンスタンプカード(CoGCaカード)の『28』より始まる13桁の番号をご入力ください。正しい番号がご入力されていない場合、オギノネットスーパーのご利用によるポイント付与ができません。",
          "infoCaption": "ポイントの加算は商品お届け日の1~2日後を予定しています。再発行や旧グリーンスタンプカードからCoGCa(コジカ)カードへ切替した場合、登録内容の変更をお願いいたします。",
          "orderConfirmDescription": "オギノグリーンスタンプCoGCaカードをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/f182be62a6084b2f85217902e718405b"
        },
        "stailerDoesNotEstimatePoint": {},
        "disableEarnedPointInReceipt": {},
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED",
        "hasRedeliveryFee": true
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "オギノネットスーパー",
      "shortName": "オギノ"
    }
  },
  "seisenichibatop_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {
            "defaultPaperPickingListSelecting": "PAPER_PICKING_LIST_SELECTING_NEXT_DAY"
          },
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableProductOriginLabelPrinting": true,
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/2583e22d636841fc9cf4f6dcb8104817"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "店舗受取専用カウンター"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/2a398ff274b44c1198d3af018b4f48a8"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/seisenichibatop_advertised-product.png"
        },
        {
          "badgeId": 2,
          "label": "日替わり",
          "imagePath": "/icons/sales_badges/seisenichibatop_daily-sale-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "bab86a76-4c8e-426b-90fe-b27b7d39168a"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "disablePointCard": {}
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {},
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "生鮮市場TOP！ネットスーパー",
      "shortName": "生鮮市場TOP！"
    }
  },
  "shizutetsustore_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.25
          },
          "productCodeScanLogicType": "PRODUCT_CODE_SCAN_LOGIC_TYPE_B"
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/1d63747cdaf181ceabd1d7e85fe6faf0"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "サービスカウンター"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_SECOND"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/1d63747cdaf1808ebc98c69dc657a0c5"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "おすすめ",
          "imagePath": "/icons/sales_badges/shizutetsustore_recommended.png"
        },
        {
          "badgeId": 2,
          "label": "いい値チョイス",
          "imagePath": "/icons/sales_badges/shizutetsustore_nice-value-choice.png"
        },
        {
          "badgeId": 3,
          "label": "得々の市",
          "imagePath": "/icons/sales_badges/shizutetsustore_tokutoku-no-ichi.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200008207826",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAy8YUk3JzZyYcLFqNWYrr4MA8LL1WTeji4GGeoFmgpFcxhqjVb8QK5+kOKuzamrzjCqAO4sPRvm4aHtktbcau5pFcXQveREk4lqQDA5LnYfaPMjB0aFVxUHKoz011OV2tjwDUKwSk66GBK09RRyFfXBGTkSpYHRphr9QElhB4iVJWz3Bm8v/DcgQHxdBW1MlpU6mkCk2y/Q9A9x0U0I3R4bYC0QjpkzKHej+Pc09O4DXQjda+3aVntl8GcUED8QECBYCVSUWaAmpQ7cX7BP0B9rep1j2Bj1SEklv4Q8UdDXmuzXLCr9TU9UZaZN5ujDod1jpJscclOJtXdclRchZciQIDAQAB",
                "keyHash": "382031406abd6750392462ec5df82414cd5c99ee18f11c8eb59d88db41313fc1"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 9,
          "formLabel": "LuLuCa",
          "registerCaption": "LuLuCaカードを登録してください",
          "infoCaption": "ポイントの加算は、商品お届け日の2~3日後を予定しています。",
          "orderConfirmDescription": "LuLuCaカードを登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/1d63747cdaf1812bb513e1435a8218d7"
        },
        "stailerDoesNotEstimatePoint": {},
        "disableEarnedPointInReceipt": {},
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "しずてつストアネットスーパー",
      "shortName": "しずてつストア"
    }
  },
  "stnet_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {
            "defaultPaperPickingListSelecting": "PAPER_PICKING_LIST_SELECTING_NEXT_DAY"
          },
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.2
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/2b23747cdaf18097b153c1708efb2ab8"
          }
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/2b23747cdaf1819faf80d4af2ecde09d"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "TRIALオリジナル",
          "imagePath": "/icons/sales_badges/stnet_trial-original.png"
        },
        {
          "badgeId": 2,
          "label": "エキサイティングプライス",
          "imagePath": "/icons/sales_badges/stnet_exciting-price.png"
        },
        {
          "badgeId": 3,
          "label": "総力祭",
          "imagePath": "/icons/sales_badges/stnet_souryokusai.png"
        },
        {
          "badgeId": 4,
          "label": "感謝祭",
          "imagePath": "/icons/sales_badges/stnet_kanshasai.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200009190615",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1NWbyR2WtHAMv3qL2uaTKQ+2jLbl4DvEzN0+ig63sxi5PfwWlztR3b4kV3Iy7QvnWyGb+XJlTWCLplmW+DPcVXLiCjpX41wUEuKS9jH41bSwqEgVpHsNRO0+3LI2q4Z4j4E2+EBSaQI8J185QIqTLAJcphXvBrcfLWj4rmhwSBMTl6tJGCxvF9Z1OoqB5qxPftZ0mDKlTIGPKUqoY1YFaoD8TFWWfv712UzFSnyVYkjuWeMZnqwYw3mjPcwsxS6iW7rSwrdm5U+aCveuy/HAQ4WawTPaQpHyDjHmIOC6SOKF82mJ3mOn1KC6GGpIGQQB7aZIq9l1JfZpcErF3H7O1wIDAQAB",
                "keyHash": "2c31c47fb8be02fa787ddba04f0d613336404218f13cea23fb509f9a53c450b6"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 13,
          "formLabel": "SU-PAY",
          "registerCaption": "SU-PAYまたはトライアルカードの会員番号をご登録ください",
          "infoCaption": "ポイントの付与は即時には付与されません。",
          "orderConfirmDescription": "SU-PAYをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/2b23747cdaf18014a4cdddfc131f46ef"
        },
        "stailerDoesNotEstimatePoint": {},
        "disableEarnedPointInReceipt": {},
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {},
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "トライアルネットスーパー",
      "shortName": "トライアル"
    }
  },
  "sugi_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          }
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "specified": {
            "digit": 4
          },
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.25
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "dss": {}
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/ea5a6394f4ab490cb7ca016b30f9607f"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "レジ周辺"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/b1cee2220a1d41dd88deab6d3a754457"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "期間特売",
          "imagePath": "/icons/sales_badges/sugi_time-sale.png"
        },
        {
          "badgeId": 2,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/sugi_advertised-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "c1f401f7-4196-4437-96fa-7e9145f7de0e"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 13,
          "formLabel": "スギポイントカード",
          "registerCaption": "スギポイントカードを連携してください",
          "infoCaption": "スギ薬局アプリで登録されたポイントカードと紐づいています。ポイントカード番号等はスギ薬局のアプリからご確認ください",
          "orderConfirmDescription": "スギポイントカードをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/e99abf4789b747339e112511ec420f6d"
        },
        "stailerDoesNotEstimatePoint": {},
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        },
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "スギスマホオーダー",
      "shortName": "スギ薬局"
    }
  },
  "torisen_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {},
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          },
          "enableInputNotFoundReason": true
        },
        "packing": {
          "staffAppPackingList": {}
        },
        "productCode": {
          "codeType": "PRODUCT_CODE_TYPE_SCAN_CODE"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.1
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "disableCashOnDeliverySettlement": {}
              }
            },
            {
              "dss": {}
            }
          ],
          "disableRedelivery": {}
        },
        "disableLifeInStoreArrangedDelivery": {},
        "disableStoreDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_DOWN",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "stailerInquiry": {
        "inquiryUrl": "https://10xall.notion.site/20fe1c2a4bdb4d30b2fb340b684cd33a"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "enableBrazeCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "ネット限定",
          "imagePath": "/icons/sales_badges/torisen_net-super-only-product.png"
        },
        {
          "badgeId": 2,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/torisen_advertised-product.png"
        },
        {
          "badgeId": 3,
          "label": "いち推し",
          "imagePath": "/icons/sales_badges/torisen_recommended-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "veritrans": {
              "development": {
                "tokenApiKey": "951b96a9-07bd-4cc4-8d8d-406c2ce467e8"
              },
              "production": {
                "tokenApiKey": "d7210992-4dd7-4ecc-a782-d6ec54a4c0e2"
              }
            }
          }
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 3
      },
      "enablePointCard": {
        "standard": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 16,
          "formLabel": "とりせんポイントカード",
          "registerCaption": "とりせんポイントカードを連携してください",
          "infoCaption": "※ポイント付与はご利用月の翌月１０日頃までにご利用金額に応じてポイント付与致します。\n※クレジット決済の為、お買上４００円（税抜）で１ポイントを付与致します。\n※月額金額の１００円単位が３００円以下は切り捨てとなりますのでご了承ください。\n",
          "orderConfirmDescription": "とりせんポイントカードをアプリに登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/bc8f9a8d3c454859a220ba8beadb3065"
        },
        "stailerEstimatesPoint": {
          "estimationParameter": {
            "pointReturnRate": "0.0025",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "specifiedGrantTargetPaymentMethods": {
              "paymentMethods": [
                "POINT_GRANT_TARGET_PAYMENT_METHOD_CREDIT_CARD"
              ]
            }
          }
        },
        "disableEarnedPointInReceipt": {},
        "enableUnlink": true
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {
        "enableStockOutAlternative": true
      },
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_INCLUDED"
      }
    },
    "salesReport": {
      "manualFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "とりせんネットスーパー",
      "shortName": "とりせん"
    }
  },
  "yakuodo_service_specification.json": {
    "fulfillment": {
      "stailerPickPack": {
        "picking": {
          "enableDayBeforePicking": {},
          "pickingList": {},
          "paperPickingList": {
            "enableDisplayingBarcode": true
          },
          "staffAppPickingList": {
            "enableDisplayingProductCode": true
          }
        },
        "packing": {
          "containerLabelSize": "CONTAINER_LABEL_SIZE_SMALL",
          "staffAppPackingList": {
            "enableDisplayingProductCode": true
          }
        },
        "productCode": {
          "specified": {
            "digit": 3
          },
          "codeType": "PRODUCT_CODE_TYPE_PRODUCT_ID"
        },
        "indefiniteProduct": {
          "fixedPricingCapableItemUnitPriceRateRange": {
            "lowerRate": 1,
            "upperRate": 1.3
          }
        }
      },
      "deliveryMethod": {
        "enableHomeDelivery": {
          "homeDeliveryServices": [
            {
              "stailerTms": {
                "enableOutgoingCall": true,
                "disableCashOnDeliverySettlement": {}
              }
            }
          ],
          "enableRedelivery": {
            "howToRedeliveryUrl": "https://10xall.notion.site/a2feabb4a7744598a52fe4a715e94e6d"
          }
        },
        "enableStoreDelivery": {
          "pickUpLocationName": "レジ周辺"
        },
        "disableLifeInStoreArrangedDelivery": {}
      }
    },
    "merchandising": {
      "disableCatalog": {},
      "approximatePrice": {
        "taxIncludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxExcludedRounding": "ROUNDING_MODE_ROUND_HALF_UP",
        "taxIncludedDecimalDigits": "TAX_INCLUDED_DECIMAL_DIGITS_ZERO"
      },
      "medicine": {},
      "alcohol": {}
    },
    "communication": {
      "email": {
        "sender": {}
      }
    },
    "customerSupport": {
      "zendeskInquiry": {
        "inquiryUrl": "https://10xall.notion.site/82f919d90c6f4c679f3a8f0b813d79ec"
      },
      "disableIvr": {}
    },
    "compliance": {},
    "marketing": {
      "disableCrm": {},
      "notification": {
        "enableSendAnnouncementToGuest": true
      },
      "salesBadges": [
        {
          "badgeId": 1,
          "label": "激得",
          "imagePath": "/icons/sales_badges/yakuodo_gekitoku-product.png"
        },
        {
          "badgeId": 2,
          "label": "広告の品",
          "imagePath": "/icons/sales_badges/yakuodo_chirashi-product.png"
        }
      ]
    },
    "payment": {
      "availablePaymentMethods": [
        {
          "creditCard": {
            "gmoPg": {
              "development": {
                "host": "https://stg.token.mul-pay.jp",
                "shopId": "tshop00044568",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlhKDXlWw4tu2JrbFITYUDT82BH2W8rLZ9OMFifrYIjO8fz12EsP+Xo+I/xUeh1ctTjGOIQYzZHYacWQ+xjNE5NSF5Beilcn2It0ST8EuQEb0NpRcm7BnYgVP7vYROXUFHiyrOUlPopSW4o+31IKwmO7VtTmq4iHZspMF/25YahIbOJfFF0uMAdIJYRxpYwIS5LWQB0zMT1G70tIGU6yIe3ciN7Le7phljZFidnM+EVSaauela9U8uL00WxTFudpybEwpDTX4zYoE5Cd1DWhZt4pSeKpqEiBMzK/siF1tkPBFifU+VH0e8L8+3n6/v52NwMnhPkoeHdDyLgl1tJnWJwIDAQAB",
                "keyHash": "59e3e2708cdd699bfc9d3e8029350b4704c43591b52992f428190ee069cebcc1"
              },
              "production": {
                "host": "https://p01.mul-pay.jp/",
                "shopId": "9200003003898",
                "pubKey": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsXrV87L4biIixlGmuzi+ZeOAnCxmKPXrUKd0a1mWDeZaWWPGzFYg9yGfZ+igXjD66HLmORlkQ7QNEpoDu9qCExi6RkhnPV+O9eVVroxN5WhzSBZHbh04Bg8mgZp5/ZfnROZZhjzVGsKvowDV4WXFzIr86nRCK9udl3/xBECrrb7BGc6zLlq656HFgg7cDRe/bLc1Qs0aj4AsTwxlQut527caEbV9mUXgx6s4y1abYYAc843xEuUshrFiWuQx0U/YMB/TRR8C9C4pAjH+5+BYRjfbN4/Q7zIqQ2WqO8keluG8BK0QlbBLObhV3MulKPL/7GgCQqTARq6ZLsYVNZECfwIDAQAB",
                "keyHash": "b7f601f872876919a98bdcf823ace193df1d3f87104583075f26c5b2a956e643"
              }
            }
          }
        },
        {
          "localPayment": {}
        }
      ],
      "salesFinalization": {
        "captureLookbackDays": 1
      },
      "enablePointCard": {
        "waica": {},
        "storeCardNumber": {},
        "uiSetting": {
          "cardNumberMaxLength": 16,
          "formLabel": "カード番号",
          "registerCaption": "WA!CAカードを登録してください",
          "infoCaption": "※アプリからポイントを利用することはできません\n※前日21時までに獲得したポイントが表示されています",
          "orderConfirmDescription": "WA!CAカードをお持ちの場合、アプリにカード情報を登録するとポイントを貯めることができます。",
          "setupGuideUrl": "https://10xall.notion.site/3a3314fb6e874a96b2f637fcac0cb8cd"
        },
        "stailerEstimatesPoint": {
          "showEstimatedPoint": true,
          "estimationParameter": {
            "pointReturnRate": "0.005",
            "unitTaxRounding": "UNIT_TAX_ROUNDING_FLOOR",
            "allPaymentMethodsGranted": {}
          }
        },
        "enableEarnedPointInReceipt": {
          "useDefaultComment": {}
        }
      }
    },
    "masterData": {},
    "customerOrder": {
      "customerRequest": {},
      "orderConfirmation": {},
      "enableStaffProductAddition": true,
      "fee": {
        "feeTaxType": "TAX_TYPE_EXCLUDED"
      }
    },
    "salesReport": {
      "schedulerFinalization": {}
    },
    "account": {
      "enableBusinessCustomer": {},
      "passwordAuthentication": {}
    },
    "service": {
      "name": "薬王堂 P!ck and",
      "shortName": "薬王堂"
    }
  }
};
